import { useQuery, useMutation } from '@tanstack/react-query';
import { api, type EventAnalytics, type PlatformAnalyticsData } from '../api/client';

export function useEventAnalytics(eventId: string) {
  return useQuery<EventAnalytics>({
    queryKey: ['analytics', 'event', eventId],
    queryFn: () => api.analytics.getEventAnalytics(eventId),
    enabled: !!eventId,
    refetchInterval: 60_000,
  });
}

export function usePlatformAnalytics(from?: string, to?: string) {
  return useQuery<PlatformAnalyticsData>({
    queryKey: ['analytics', 'platform', from, to],
    queryFn: () => api.admin.analytics(from, to),
    refetchInterval: 60_000,
  });
}

export function useTrackReferralClick() {
  return useMutation({
    mutationFn: (data: { source: string; referrer?: string; eventId?: string; ipHash?: string }) =>
      api.referral.trackClick(data),
  });
}
